import { z } from 'zod/v4'

export const userGeneralValidation = () => {
  return z.object({
    name: z.string().min(1, { message: 'Form is required' }),
    email: z.string().min(1, { message: 'Form is required' }).email('Invalid email format'),
    phone: z.string().min(4, { message: 'Form is required' }),
    active: z.coerce.boolean(),
    country_signup: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    city_signup: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    referral_code: z.string().optional().or(z.literal('')),
    survey: z.string().min(1, { message: 'Form is required' }),
    can_order: z.string().min(1, { message: 'Form is required' }),
    marking_codes: z.array(z.string()).optional(),
    change_password: z.coerce.boolean(),
    password: z.string().optional(),
    password_confirmation: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.change_password) {
        return data.password.length >= 8
      } else {
        return true
      }
    },
    {
      message: 'Password is required (min 8 characters)',
      path: ['password'],
    }
  )
  .refine(
    (data) => {
      if (data.change_password) {
        return data.password_confirmation === data.password
      } else {
        return true
      }
    },
    {
      message: 'Password confirmation is not match',
      path: ['password_confirmation'],
    }
  )
}